module.exports = __webpack_public_path__ + "static/img/icon-insurance-06.1b534924.png";